/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Editor_Token_InvalidInputs */

const fr_settings_editor_token_invalid = /** @type {(inputs: Settings_Editor_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun contributeur n'existe avec ce jeton.`)
};

const en_settings_editor_token_invalid = /** @type {(inputs: Settings_Editor_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contributor exists with this token.`)
};

/**
* | output |
* | --- |
* | "No contributor exists with this token." |
*
* @param {Settings_Editor_Token_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_editor_token_invalid = /** @type {((inputs?: Settings_Editor_Token_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Editor_Token_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_editor_token_invalid(inputs)
	return en_settings_editor_token_invalid(inputs)
});